/**
 * FAQ data structure.
 */
export interface FAQData {
  question: string
  answer: string
}

/**
 * Generates an FAQ schema.org object from FAQ data.
 * @param faqs - List of FAQData
 * @returns An object with faqs, faqsExist, and faqSchema (or null)
 */
export function createFAQSchemaFromData(faqs: FAQData[]): {
  faqs: FAQData[]
  faqsExist: boolean
  faqSchema: any
} {
  const faqsExist: boolean = faqs.length > 0
  let faqSchema: any = null
  if (faqsExist) {
    try {
      if (
        Array.isArray(faqs) &&
        faqs.length > 0 &&
        faqs.every(
          faq =>
            faq?.question &&
            typeof faq.question === 'string' &&
            faq?.answer &&
            typeof faq.answer === 'string',
        )
      ) {
        faqSchema = {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map(faq => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer,
            },
          })),
        }
      } else {
        console.warn('FAQs exist but have invalid structure:', faqs)
      }
    } catch (error) {
      console.error('Error parsing FAQs:', error)
    }
  }

  return { faqs, faqsExist, faqSchema }
}
